module.exports = __webpack_public_path__ + "a16ebf82d899ab0722df80417708e324.jpg";